$(document).on("metaslug_sinhnhat1tuoi_milestone rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $(".btn_close").on("click", function (e) {
        $(".tooltip").addClass("d-none");


    });
    $(".reward__moc img").on("click", function (e) {
        $(".tooltip").removeClass("d-none");

    });



});